export default function gameRecordId(
  sessionId: string,
  gameId: string
): `${string}::${string}` {
  return `${sessionId}::${gameId}`;
}
